import { testimonials } from "@/data/siteContent";
import { Card } from "@/components/ui/card";
import { Star } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { motion } from "framer-motion";
import { TESTIMONIALS } from "@/constants/testIds";

const initials = (name) => name.split(" ").map((n) => n[0]).join("").slice(0, 2).toUpperCase();

export const Testimonials = () => {
  return (
    <section id="testimonianze" data-testid={TESTIMONIALS.section} className="py-16 sm:py-24">
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <p className="text-sm font-semibold text-accent uppercase tracking-wider">Recensioni</p>
          <h2 className="mt-2 text-3xl sm:text-4xl font-semibold tracking-tight">Cosa dicono i nostri clienti</h2>
          <p className="mt-4 text-muted-foreground text-base leading-relaxed">
            Migliaia di famiglie e professionisti si affidano a controllatelefoni.it ogni giorno.
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.45, delay: (i % 3) * 0.07, ease: [0.22, 1, 0.36, 1] }}
            >
              <Card className="h-full p-6 rounded-2xl border-border glow-hover bg-card">
                <div className="flex items-center gap-1">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star key={k} className={`h-4 w-4 ${k < t.rating ? "fill-amber-400 text-amber-400" : "text-muted-foreground/30"}`} />
                  ))}
                </div>
                <p className="mt-4 text-sm text-foreground/90 leading-relaxed">“{t.text}”</p>
                <div className="mt-5 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-accent font-semibold text-sm glow">
                    {initials(t.name)}
                  </span>
                  <div>
                    <p className="text-sm font-semibold">{t.name}</p>
                    <p className="text-xs text-muted-foreground">{t.role}</p>
                  </div>
                </div>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
